"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _modal, _isLmsModal;
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
Entry.Modal = (_modal = /*#__PURE__*/new WeakMap(), _isLmsModal = /*#__PURE__*/new WeakMap(), /*#__PURE__*/function () {
  function EntryModal() {
    (0, _classCallCheck2["default"])(this, EntryModal);
    _classPrivateFieldInitSpec(this, _modal, null);
    _classPrivateFieldInitSpec(this, _isLmsModal, false);
  }
  return (0, _createClass2["default"])(EntryModal, [{
    key: "modal",
    get: function get() {
      if (!_classPrivateFieldGet(_modal, this)) {
        if (window.EntryModal) {
          _classPrivateFieldSet(_modal, this, window.EntryModal);
        } else {
          _classPrivateFieldSet(_modal, this, entrylms);
          _classPrivateFieldSet(_isLmsModal, this, true);
        }
      }
      return _classPrivateFieldGet(_modal, this);
    }
  }, {
    key: "alert",
    value: function alert(content, title, options) {
      var _this = this;
      if (_classPrivateFieldGet(_isLmsModal, this)) {
        return new Promise(function (resolve) {
          _this.modal.alert(content, title, options).on('hide', function (result) {
            return resolve(result);
          });
        });
      }
      return this.modal.alert(content, title, options);
    }
  }, {
    key: "confirm",
    value: function confirm(content, title, options) {
      return this.modal.confirm(content, title, options);
    }
  }]);
}());